"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OfferSearch = void 0;
var _react = require("react");
var _useDebounce = require("use-debounce");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
// istanbul ignore file -- no need to test this file
const OfferSearch = ()=>{
    const { formatMessage } = (0, _hooks.useTranslations)();
    const { searchTerm, setSearchTerm } = (0, _contexts.useOfferDetail)();
    const [value, setValue] = (0, _react.useState)(searchTerm);
    const debouncedSet = (0, _useDebounce.useDebouncedCallback)((val)=>setSearchTerm(!val || val === '' ? undefined : val), 500);
    const onClear = (0, _react.useCallback)(()=>{
        debouncedSet.cancel();
        setValue(undefined);
        setSearchTerm(undefined);
    }, [
        debouncedSet,
        setSearchTerm
    ]);
    const onChange = (0, _react.useCallback)((e)=>{
        const val = e.target.value;
        setValue(val);
        debouncedSet(val);
    }, [
        debouncedSet
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.SearchInput, {
        fullWidth: true,
        variant: "filled",
        color: "primary",
        InputProps: {
            startAdornment: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.SearchIcon, {}),
            endAdornment: value ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ClearButton, {
                onClick: onClear,
                onMouseDown: onClear,
                onTouchStart: onClear
            }) : null
        },
        placeholder: formatMessage('searchOffers'),
        value: value !== null && value !== void 0 ? value : '',
        onChange: onChange
    });
};
exports.OfferSearch = OfferSearch;
